import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

import { ButtonProps } from '.';
import { getCssBySize, getCssByVariant } from './helper';

interface LoadingProps {
  $loading?: boolean;
}

export const darkButton = css`
  background-color: ${({ theme }) => theme.colors.gray900};
  color: ${({ theme }) => theme.colors.white100};

  &:active,
  &:hover,
  &:focus,
  &:link,
  &:visited {
    color: ${({ theme }) => theme.colors.white100};
  }
`;

export const lightButton = css`
  background-color: ${({ theme }) => theme.colors.white100};
  color: ${({ theme }) => theme.colors.gray900};
  border: 1px solid ${({ theme }) => theme.colors.gray400};

  &:active,
  &:hover,
  &:focus,
  &:link,
  &:visited {
    color: ${({ theme }) => theme.colors.gray900};
  }
`;

export const magentaButton = css`
  background-color: ${({ theme }) => theme.colors.magenta700};
  color: ${({ theme }) => theme.colors.white100};

  &:active,
  &:hover,
  &:focus,
  &:link,
  &:visited {
    color: ${({ theme }) => theme.colors.white100};
  }
`;

export const lgButton = css`
  height: 48px;
  padding: 0 40px;
  ${getFontStyle('bold150_B1')}
`;

export const mdButton = css`
  height: 40px;
  padding: 0 30px;
  ${getFontStyle('bold150_B3')}
`;

export const smButton = css`
  padding: 0 20px;
  height: 32px;
  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  ${getFontStyle('bold120_C1')}
`;
export const ButtonInner = styled.span<LoadingProps>`
  display: flex;
  align-items: center;

  ${({ $loading }) =>
    $loading &&
    css`
      opacity: 0;
    `}
`;

export const LoadingWrapper = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);

  svg {
    vertical-align: top;
  }
`;

export const Button = styled.button<
  Pick<ButtonProps, 'variant' | 'size' | 'inlineCss' | 'loading'>
>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 50px;
  outline: 0;
  border-width: 0;
  white-space: pre;

  &[disabled] {
    ${({ loading }) =>
      !loading &&
      css`
        background-color: ${({ theme }) => theme.colors.gray500};
      `}
  }

  ${({ variant }) => getCssByVariant(variant)};
  ${({ size }) => getCssBySize(size)};
  ${({ inlineCss }) => inlineCss};
`;
